import { formatText } from '../../helpers/value'
import { positionDropdown } from '../dropdown'
import { TextEllipsisStaticLine } from '../textEllipsis/TextEllipsisStaticLine'

export const EventCell = ({ val }) => {
  return (
    <TextEllipsisStaticLine
      zIndexTooltip={7}
      text={formatText(val)}
      isI18n={false}
      lineClamp={1}
      tooltipMaxWidthByContent={true}
      tooltipPosition={positionDropdown.BOTTOM_CENTER}
    />
  )
}
